import moment from "moment";
import ClearIcon from '@mui/icons-material/Clear';
import AnswerCell from "./AnswerCell";
import { getStateOfPoll } from "../../helpers/utils";
import SweetAlert from "../SweetAlert/SweetAlert"
import Swal from 'sweetalert2';
import { archivePoll, deletePoll, endPoll, startPoll, getPollById, openOptionalInfoModelPoll } from "../../store/slices/pollSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import InfoIcon from '@mui/icons-material/Info';
import { useSocket } from "./../../context/SocketContext";
const PollCell = ({ poll }) => {

    const dispatch = useDispatch();
    const { isArchiving, isUpdating } = useSelector((state) => state.poll);
    const auth = useSelector((state) => state.auth);
    const { socket } = useSocket();

    const roomId = auth?.user?.attributes?.stationChatId;

    const totalVotesCount = poll?.relations?.answers?.data.reduce((sum, answer) => sum + (answer.votesCount || 0), 0) || 0;
    const started = poll.attributes.state == 1;
    const archived = poll.attributes.state == 4;
    const stopped = poll.attributes.state == 2 || poll.attributes.state == 3;
    const { isScheduled, tz, displayData, image, description } = poll.attributes;
    const scheduledData = displayData ? JSON.parse(displayData) : {};

    const hasImage = image && image.trim() !== '';
    const hasDescription = description && description.trim() !== '';
    const hasMediaContent = hasImage || hasDescription;


    const archivePollAction = async () => {
        try {
            await dispatch(archivePoll({ id: poll.id })).unwrap();
            socket.emit('poll.archived', { poll, roomId });
        } catch (error) {
            console.error('Error archiving poll:', error);
        }
    };

    const endPollAction = async () => {
        try {
            await dispatch(endPoll({ id: poll.id })).unwrap();
            socket.emit('poll.stoped', { poll, roomId });
        } catch (error) {
            console.error('Error ending poll:', error);
        }
    };

    const startPollAction = async () => {
        try {
            await dispatch(startPoll({ id: poll.id })).unwrap();
            socket.emit('poll.start', { poll, roomId });
        } catch (error) {
            console.error('Error starting poll:', error);
        }
    };


    const deleteAction = async () => {
        if (started) {
            Swal.fire("Not Allowed!", "This poll is active. Please stop it before deleting.", "error");
            return false;
        }


        SweetAlert({
            title: "Delete Poll",
            text: 'Do you want to erase this poll permanently?',
            showSuccessAlert: false,
            confirmAction: async () => {
                Swal.showLoading();
                await dispatch(deletePoll({ id: poll.id, socket })).unwrap();
                socket.emit(`poll.deleted`, { poll, roomId });
            }
        });
    }
    return (
        <div className="poll-cell border">
            <div className="pb-2">
                <div className="top-section">
                    <div className="header-section">
                        <span className="question-heading text-wrap">{poll.attributes.title}</span>
                        <span className="status">status: {getStateOfPoll(poll.attributes.state)}</span>
                    </div>
                    <div className="d-flex">
                        {hasMediaContent && (
                            <button
                                className="dull-button me-2" style={{ right: "56px" }}
                                onClick={() => dispatch(openOptionalInfoModelPoll({ image, description }))}
                                title="Show optional Information"
                            >
                                <InfoIcon />
                            </button>
                        )}

                        <button className="dull-button" style={{ right: "30px" }} onClick={
                            () => {
                                dispatch(getPollById({ id: poll.id }));
                            }
                        }>
                            {!archived && <EditIcon />}
                        </button>
                        <button className="dull-button" onClick={deleteAction}><ClearIcon /></button>
                    </div>
                </div>
                <div className="answer-section">
                    <div>
                        {poll?.relations?.answers?.data?.map((answer, index) => (
                            <AnswerCell key={index} answerIndex={index} answer={answer} totalVotesCount={totalVotesCount} />
                        ))}
                    </div>
                    {archived !== true && stopped !== true && (isScheduled == 1 || isScheduled == 2) && < div style={{ textAlign: 'left', border: '1px solid lightgray' }} className="p-3">
                        {isScheduled == 1 && !started &&
                            <div>
                                <div style={{ fontSize: '12px' }}>
                                    <p>
                                        <strong>Poll is Scheduled :</strong>
                                    </p>
                                    <table style={{ width: '100%' }}>
                                        <tr>
                                            <td>Start Time: </td>
                                            <td>{scheduledData.startDate} {scheduledData.startTime} ({tz})</td>
                                        </tr>
                                        <tr>
                                            <td>End Time: </td>
                                            <td>{scheduledData.endDate} {scheduledData.endTime} ({tz})</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>}

                        {isScheduled == 2 && started &&
                            <div>
                                <div style={{ fontSize: '12px' }}>
                                    <p>
                                        <strong>Poll is Scheduled :</strong>
                                    </p>
                                    <table style={{ width: '100%' }}>
                                        <tr>
                                            <td>End Time: </td>
                                            <td>{scheduledData.endDate} {scheduledData.endTime} ({tz})</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>}

                    </div>}
                </div>
                <div className="footer-section">
                    {archived !== true && (
                        <div className="d-flex justify-content-end">
                            {(stopped) && (
                                <div className="px-1">
                                    <button
                                        disabled={isArchiving === 0}
                                        className="btn btn-outline-secondary f-11 px-4"
                                        onClick={archivePollAction}
                                    >
                                        {isArchiving ? (
                                            <span className="d-flex gap-1">
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                Wait...
                                            </span>
                                        ) : 'Archive'}
                                    </button>
                                </div>
                            )}
                            <div className="px-1">
                                <button
                                    className="btn btn-dark f-11 px-4"
                                    disabled={isUpdating === 0}
                                    onClick={started ? endPollAction : startPollAction}
                                >
                                    {isUpdating ? (
                                        <span className="d-flex gap-1">
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Wait...
                                        </span>
                                    ) : started ? (
                                        'Stop'
                                    ) : stopped ? (
                                        'Resume'
                                    ) : isScheduled ? (
                                        'Start Now'
                                    ) : (
                                        'Start'
                                    )}
                                </button>
                            </div>
                        </div>
                    )}

                </div>

            </div>
        </div>
    )
};

export default PollCell;